/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Severity of the alert.
 */
export enum ResourceAlertSeverityType {
  ResourceAlertSeverityTypeWarning = 'Warning',
  ResourceAlertSeverityTypeCritical = 'Critical',
  ResourceAlertSeverityTypeInfo = 'Info',
}
